import {
  FiArrowLeft,
  FiCheckCircle,
  FiChevronLeft,
  FiChevronRight,
  FiExternalLink,
  FiGithub,
  FiStar,
} from "react-icons/fi";
import { Link, Navigate, useParams } from "react-router-dom";

import DifficultyBadge from "../components/ui/DifficultyBadge";
import LazyImage from "../components/ui/LazyImage";
import TopicPill from "../components/ui/TopicPill";
import { numberedProjects } from "../data/projects";

const ProblemDetail = () => {
  const { slug } = useParams();
  const index = numberedProjects.findIndex((p) => p.slug === slug);
  if (index === -1) return <Navigate to="/problems" replace />;

  const project = numberedProjects[index];
  const prev = numberedProjects[index - 1];
  const next = numberedProjects[index + 1];

  return (
    <div className="page problem-detail">
      <Link to="/problems" className="back-link">
        <FiArrowLeft /> Back to Problems
      </Link>

      <div className="pd-header">
        <h1 className="pd-title">
          <span className="pd-number">{project.number}.</span> {project.title}
        </h1>
        <div className="pd-header-meta">
          <DifficultyBadge difficulty={project.difficulty} />
          <span className="pd-status">
            <FiCheckCircle /> Accepted
          </span>
          <span className="chip">{project.category}</span>
          {project.featured && (
            <span className="featured-tag">
              <FiStar /> Featured
            </span>
          )}
        </div>
      </div>

      <div className="pd-grid">
        <article className="lc-card pd-desc">
          <h2 className="pd-section-title">Description</h2>
          <p>{project.description}</p>

          <h2 className="pd-section-title">Tech Stack</h2>
          <div className="pd-tags">
            {project.tags.map((t) => (
              <TopicPill key={t} name={t} size="sm" />
            ))}
          </div>

          <div className="pd-actions">
            {project.github && (
              <a
                className="lc-btn lc-btn-outline"
                href={project.github}
                target="_blank"
                rel="noreferrer"
              >
                <FiGithub /> Source Code
              </a>
            )}
            {project.demo && (
              <a
                className="lc-btn lc-btn-primary"
                href={project.demo}
                target="_blank"
                rel="noreferrer"
              >
                <FiExternalLink /> {project.demoLabel || "Live Demo"}
              </a>
            )}
          </div>
        </article>

        <aside className="lc-card pd-preview">
          <a
            className="pd-shot"
            href={project.demo || project.github}
            target="_blank"
            rel="noreferrer"
          >
            <LazyImage src={project.image} alt={project.title} />
          </a>
          <dl className="pd-facts">
            <div>
              <dt>Status</dt>
              <dd className="pd-fact-solved">Solved</dd>
            </div>
            <div>
              <dt>Difficulty</dt>
              <dd>
                <DifficultyBadge difficulty={project.difficulty} />
              </dd>
            </div>
            <div>
              <dt>Category</dt>
              <dd>{project.category}</dd>
            </div>
          </dl>
        </aside>
      </div>

      <nav className="pd-nav">
        {prev ? (
          <Link to={`/problems/${prev.slug}`} className="pd-nav-btn">
            <FiChevronLeft /> {prev.title}
          </Link>
        ) : (
          <span />
        )}
        {next ? (
          <Link to={`/problems/${next.slug}`} className="pd-nav-btn pd-nav-next">
            {next.title} <FiChevronRight />
          </Link>
        ) : (
          <span />
        )}
      </nav>
    </div>
  );
};

export default ProblemDetail;
